function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2069 17C10.4485 17 9 18.4485 9 20.2069V29.8276C9 31.586 10.4485 33.0345 12.2069 33.0345H33.5862C35.3446 33.0345 36.7931 31.586 36.7931 29.8276V20.2069C36.7931 18.4485 35.3446 17 33.5862 17H12.2069ZM12.2069 19.1379H33.5862C34.1902 19.1379 34.6552 19.6029 34.6552 20.2069V29.8276C34.6552 30.4316 34.1902 30.8966 33.5862 30.8966H12.2069C11.6029 30.8966 11.1379 30.4316 11.1379 29.8276V20.2069C11.1379 19.6029 11.6029 19.1379 12.2069 19.1379ZM13.2759 21.2759V28.7586H32.5172V21.2759H13.2759ZM37.8621 22.3448V27.6897H38.931C39.5211 27.6897 40 27.2108 40 26.6207V23.4138C40 22.8237 39.5211 22.3448 38.931 22.3448H37.8621Z"
});

function SvgIcA39907CdC69C41829674A38D53C09Cf1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcA39907CdC69C41829674A38D53C09Cf1);
export default ForwardRef;